<template>
    <div class="course-details-container">
        <!-- Price section with proper reactivity structure -->
        <div v-if="appName != 'langtour'" class="price-section">
            <div class="reservation-heading px-3 d-flex justify-content-between align-items-center">
                <h6 class="font-weight-bold text-main-color mb-0">{{ tra.total_price }}</h6>
                <h5 class="text-main-color m-0">
                    <span class="total-price-value">{{ formattedTotalPrice }}</span>
                    <span class="small text-dark currency-code">
                        {{ formattedCurrencyCode }}
                    </span>
                </h5>
            </div>
            <hr class="mx-3 my-2">
        </div>

        <!-- Course details section -->
        <div class="px-3 course-info">
            <div class="course-name">
                <span class="d-block">{{ safeCourseName }}</span>
            </div>
            
            <div class="d-flex price-details-row">
                <!-- Same price scenario -->
                <p v-if="isSamePrice" class="text-main-color price-display">
                    <span class="weight-bold">
                        <span class="price-amount">{{ formattedCoursePrice }}</span>
                        <span class="small text-dark currency-suffix">
                            {{ formattedCurrencyCode }}
                        </span>
                    </span>
                </p>
                
                <!-- Discounted price scenario -->
                <p v-else class="text-main-color price-display">
                    <del class="text-danger ml-2 original-price">
                        <span class="price-amount">{{ formattedCoursePrice }}</span>
                        <span class="small text-dark currency-suffix">
                            {{ formattedCurrencyCode }}
                        </span>
                    </del>
                    <span class="weight-bold discounted-price">
                        <span class="price-amount">{{ formattedDiscountedPrice }}</span>
                        <span class="small text-dark currency-suffix">
                            {{ formattedCurrencyCode }}
                        </span>
                    </span>
                </p>
                
                <span class="mx-2 separator">/</span>
                <span class="h6 text-main-color d-block m-0 weeks-display">({{ weeksOutput(courseWeeks) }})</span>
            </div>
        </div>

        <hr class="mx-3 my-2">
    </div>
</template>

<script>
export default {
    name: 'CourseDetailsDisplay',
    props: {
        dataObj: {
            type: Object,
            default: () => ({})
        },
        courseWeeks: {
            type: [String, Number],
            default: 1
        },
        tra: {
            type: Object,
            default: () => ({})
        },
        appName: {
            type: String,
            default: ''
        },
    },
    computed: {
        // Safe access to dataObj with fallbacks
        safeDataObj() {
            return this.dataObj || {};
        },
        
        // Computed properties for better reactivity
        formattedTotalPrice() {
            return this.safeDataObj.total_price || 0;
        },
        
        formattedCurrencyCode() {
            const currencyCode = this.safeDataObj.currency?.code || 'SAR';
            return currencyCode === 'SAR' ? ' ' : currencyCode;
        },
        
        safeCourseName() {
            return this.safeDataObj.course?.name || '';
        },
        
        formattedCoursePrice() {
            return this.safeDataObj.course?.price || 0;
        },
        
        formattedDiscountedPrice() {
            return this.safeDataObj.course?.discounted_price || 0;
        },
        
        isSamePrice() {
            const originalPrice = this.safeDataObj.course?.discounted_price || 0;
            const currentPrice = this.safeDataObj.course?.price || 0;
            return originalPrice === currentPrice;
        }
    },
    methods: {
        weeksOutput(weeks) {
            const numWeeks = Number(weeks) || 1;
            let msg = '';
            
            if (numWeeks === 1) { 
                msg = this.tra.weeks_singular || 'اسبوع'; 
            }
            else if (numWeeks === 2) { 
                msg = this.tra.two_weeks_option || 'اسبوعان'; 
            }
            else if (numWeeks > 2 && numWeeks < 11) { 
                msg = numWeeks + ' ' + (this.tra.weeks || 'اسابيع'); 
            }
            else { 
                msg = numWeeks + ' ' + (this.tra.weeks_singular || 'اسبوع'); 
            }
            
            return msg;
        }
    },
    watch: {
        // Watch for dataObj changes to debug reactivity
        dataObj: {
            handler(newVal, oldVal) {
                console.log('CourseDetailsDisplay: dataObj changed, total_price:', newVal?.total_price);
            },
            deep: true
        }
    }
};
</script>

